export const resolveJobId = ({
	enableInternalJobId,
	internalJobId,
	jobId,
}: {
	enableInternalJobId: boolean;
	internalJobId?: string | null;
	jobId: number;
}): string => {
	return `${enableInternalJobId && internalJobId ? internalJobId : jobId}`;
};
